//// =====================================================
//   Production
//// =====================================================
export const Environment = {
    finance: 'https://leanfinance.ertikaz-tech.com',
    financePro: 'https://financePro.ertikaz-tech.com',
    financeApi: 'https://leanfinance-api.ertikaz-tech.com',
    financeProApi: 'https://financepro-api.ertikaz-tech.com',
    ertikazApi: 'https://shared.ertikaz.tech',
    publicAip:'https://public-api.ertikaz.tech'
}
